// Mapper: transport LC_GetTodayTardinessSummaryOut → domain model for the
// "Mi equipo" dashboard "Situación de asistencia" section — "Atraso" card
// (ASIS-5405 / REXASIS-004).
// The backend only sends the raw counts; the percentage/isEmpty business rules are
// computed here so the UI never re-implements them.

import type {
  LC_GetTodayTardinessSummaryOut,
  MyTeamTardinessSummary,
} from '../types/myTeamTardinessSummary.types';


export function mapMyTeamTardinessSummary(
  out: LC_GetTodayTardinessSummaryOut,
): MyTeamTardinessSummary {
  const isEmpty = out.totalSupervisedCount === 0;
  const percentage = isEmpty
    ? 0
    : Math.round((out.lateCount / out.totalSupervisedCount) * 100);

  return {
    lateCount: out.lateCount,
    totalSupervisedCount: out.totalSupervisedCount,
    percentage,
    isEmpty,
  };
}
